/**
 * @module transactionStatus
 * @description A list of transaction status
 */

export const transactionStatus = ['pending', 'success', 'failed'] as const;
export type TransactionStatus = (typeof transactionStatus)[number];
